import {Component, Inject, ViewChild} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {takeUntil} from 'rxjs/operators';

import {AppService} from 'app/services/app.service';
import {BaseDatasetActionDialog, IDialogData} from './../../base-action-dialog.component';
import {DatasetService} from 'app/main/components/dataset/services/dataset.service';
import { DatasetActionContainerService } from 'app/main/components/dataset/services/dataset-action-container.service';
import { PageClosureContainerService } from 'app/main/pages/page-closure-container.service';

export interface IRestoreDialogData extends IDialogData{
	recordId: string;
	record: any;
	message?: string;
}

@Component({
	selector: 'dataset-restore-dialog',
	templateUrl: 'dataset-restore-dialog.component.html',
	styleUrls: ['dataset-restore-dialog.component.scss'],
	providers: [DatasetActionContainerService, PageClosureContainerService]
})
export class DatasetRestoreDialogComponent extends BaseDatasetActionDialog{

	actionCode = 'restore';
	message = 'Vuoi ripristinare questo record?';
	deleteError: any;

	constructor(
		public datasetACS: DatasetActionContainerService,
		public appService: AppService,
		public datasetService: DatasetService,
		public dialogRef: MatDialogRef<DatasetRestoreDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IRestoreDialogData
	) {
		super(datasetACS, appService, datasetService, dialogRef, data);
		if(data.message){
			this.message = data.message;
		}
	}

	onRestore(): void{
		this.loading = true;
		
		this.datasetService.post(this.datasetACS.getRestoreRoute(this.data.record))
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe({
			next: (response) => {
				this.loading = false;
				this.appService.showSuccessMessage('Ripristinato con successo');
				this.dialogRef.close(true);
			},
			error: err => {
				this.deleteError = err;
				this.loading = false;
			}
		});

	}

}
